class HomeBlockTop {
    /**
     * Constructor
     */
    constructor() {
        /**
         * @type {HTMLElement}
         */
        this.topBlock = document.getElementById('top-block-button');

        /**
         * @type {HTMLElement[]}
         */
        this.block = [
            document.getElementById('block_button_banner_1'),
            document.getElementById('block_button_banner_2'),
        ];
        /**
         * @type {(Element)[]}
         */
        this.bottom = [
            this.block[0].querySelector('.bottom'),
            this.block[1].querySelector('.bottom'),
        ];
        /**
         * Init animation
         */
        this._animation();
    }

    /**
     * Animation
     * @private
     */
    _animation() {
        // Block left top
        this.block[0].style.transform  = 'translateY(0)';
        this.bottom[0].style.transform = 'translateY(0)';

        //Block right top
        setTimeout(() => {
            this.topBlock.style.transform  = 'translateY(0)';
            this.block[1].style.transform  = 'translateY(0)';
            this.bottom[1].style.transform = 'translateY(0)';
        }, 100);
    }
}